import {Breadcrumbs, Title} from '@management-ui/core';
import React from 'react';
import routes from '../../../../routes';


const Wrapper = ({title, loading, titleControls, crumbs, children}) => {
  return (
    <>
      <Breadcrumbs crumbs={crumbs}/>
      <Title title={`Reporting${title ? ` - ${title}` : ''}`} loading={loading} controls={titleControls}/>
      {children}
    </>
  );
}

Wrapper.standardCrumbs = [
  {title: 'Reporting', link: routes.reporting.index},
];

export default Wrapper;
